import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const BOSupplierListModal = ({ showModal, closeModal, onSelectVehicle, branch, fld_purnumber }) => {
  const [supplier, setSupplier] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false); 

  useEffect(() => {
    if (showModal) {
      fetchVehicles();
    }
  }, [showModal, search]);

  const fetchVehicles = async () => {
    setLoading(true); // <-- Start loading
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/bo_suppliers", {
        params: { branchcode: branch, searchTerm: search }
      });
      setSupplier(response.data || []);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }
    setLoading(false); // <-- Stop loading
  };

  const handleSelect = (vehicle_code, vehicle_number) => {
    onSelectVehicle(vehicle_code, vehicle_number);
    closeModal();
  };

  return (
    <div className={`custom-modal-overlay ${showModal ? "visible" : ""}`}>
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h2>Select Supplier</h2>
          <button className="custom-modal-close" onClick={closeModal}>✖</button>
        </div>

        <input
          type="text"
          className="custom-modal-search"
          placeholder="Search Supplier..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="custom-modal-list">
          {loading ? ( 
            <p className="custom-loading-text">Loading...</p>
          ) : supplier.length > 0 ? (
            supplier.map((item, index) => (
              <div
                key={index}
                className="custom-modal-item"
                onClick={() => handleSelect(item.supplierMaster_code, item.supplierMaster_name)}
              >
                {item.supplierMaster_code} - {item.supplierMaster_name}
              </div>
            ))
          ) : (
            <p className="custom-no-data">No suppliers found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BOSupplierListModal;
